import React, { useState, useEffect } from 'react';
import cmsUtils from '../../utils/cmsUtils';
import  utils from '../../../utils';
import { SiteLink } from '../../../components';

export function SingleBanner(props) {
  const item = props.item;
  const cmsOption = props.cmsOption || {};
  const [isMobile, setIsMobile] = useState(utils.site.isMobile());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(utils.site.isMobile());
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  //console.log('item', item);
  const heightSet = cmsUtils.payload(item, 'HeightSet') || 'standard';
  const alignV = cmsUtils.payload(item, 'AlignV') || '50%';
  const alignVMobile = cmsUtils.payload(item, 'AlignV2') || '50%';

  const cssClass = utils.classNames('cms_item', 'single-banner', 'banner-item', `bannerSize--${heightSet}`, item.cssClass || item.anchorName || '');
  const bgUrl = utils.site.resourcePath(cmsUtils.payload(item, 'ImageUrl'));
  let bgUrlMobile = utils.site.resourcePath(cmsUtils.payload(item, 'ImageUrl2'));

  if (!bgUrlMobile) {
    bgUrlMobile = bgUrl;
  }

  const captionTitle = cmsUtils.payload(item, 'CaptionTitle2') || cmsUtils.payload(item, 'CaptionTitle');
  const linkUrl = cmsUtils.payload(item, 'LinkUrl2') || cmsUtils.payload(item, 'LinkUrl');

  const titlePanel = captionTitle ? (
    linkUrl ? (<SiteLink to={linkUrl} className="banner-item__link">
      <div className="banner-item__title" dangerouslySetInnerHTML={{ __html: captionTitle }}></div>
    </SiteLink>) : (<div className="banner-item__title" dangerouslySetInnerHTML={{ __html: captionTitle }}></div>)
  ) : null;

 const bannerStyles = {
    backgroundImage: utils.css.bgUrlStyle(isMobile ? bgUrlMobile : bgUrl),
    backgroundPositionY: isMobile ? alignVMobile : alignV,
  
  };

  return (
    <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}
      style={bannerStyles}>
      {titlePanel && <div className="banner_item__text">{titlePanel}</div>}
    </div>
  );


}
